import * as React from "react";
import {FastField} from "formik";
import {FormGroup} from "../../../../../../../../libs/components/libs/form/group/index";
import {Button} from "../../../../../../../../libs/components/libs/button/index";
import {RotateLoader} from "../../../../../../../../libs/components/libs/loaders/rotate/index";
import {Input} from "../../../../../../../../libs/components/libs/form/input/index";
import {Switch} from "../../../../../../../../libs/components/libs/form/switch/Switch";
import {UI} from "../../../../../../../core/ui";
import {MobxComponent} from "../../../../../../../mobx/components/index";
import {inject, observer} from "mobx-react";
import {RestaurantForm} from "../../../../../../../mobx/components/restaurant-form";
import { LinkTag } from "../../../../../../../../libs/components/libs/elements/link";

interface Props {
  close?: () => void;
}
interface State {}

type FormValues = RestaurantSchema["settings"]["integrations"];

@inject("store") @observer
export class SettingsFormIntegrationGoogleAnalytics extends MobxComponent<Props, State> {

  initialValues: FormValues;

  constructor(props: Props) {
    super(props);
    this.state = {};
    const r = this.injected.store.restaurant!;
    this.initialValues = r.settings.integrations;
  }

  render() {
    return (
      <RestaurantForm<FormValues>
        submit={async (r, values) => {
          r.settings.integrations = values;
          const update = { $set: { "settings.integrations": r.settings.integrations } };
          return { r, update };
        }}
        validators={{}}
        initialValues={this.initialValues}
        onSuccess={() => {
          if (this.props.close) {
            this.props.close();
          }
        }}
        onError={() => UI.notification.error("An error occurred")}
        onSuccessMessage="Settings Updated"
        onErrorMessage="">
        {({ form, error }) => {
          const { isSubmitting } = form;
          return (
            <div className="p-4">

              <FastField
                name="google_analytics.property_id"
                render={({ field }: any) => (
                  <FormGroup
                    title="Property / Tracking ID"
                    help="Your unique analytics property ID. It resembles the following, 'UA-XXXXXXXX-X'">
                    <Input type="text" {...field} value={field.value || ""}/>
                  </FormGroup>
                )}
              />

              {error && <FormGroup error={error}/>}

              <Button full={true} color="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting && <RotateLoader size={2} color="white"/>}
                {!isSubmitting && "Save"}
              </Button>

            </div>
          );
        }}
      </RestaurantForm>
    );

  }

}
